const ReturnsExchanges = () => {
  return (
    <div className="privacy-container m-4 shadow-4 p-5 rounded">
      <h1 className="privacy-title">Returns & Exchanges</h1>
      <p className="privacy-date">Effective Date: [29-04-2025]</p>
      <p className="privacy-website">Website: https://kidschoice.co.in</p>

      <h2>1. Return Eligibility</h2>
      <p>
        Items can be returned within 7 days of delivery. Items must be unused
        and in original packaging.
      </p>

      <h2>2. Non-returnable Items</h2>
      <p>
        Gift cards, downloadable software, and perishable goods are not eligible
        for return.
      </p>

      <h2>3. Refund Process</h2>
      <p>
        Once we receive and inspect your return, we will notify you and process
        your refund to the original payment method.
      </p>

      <h2>4. Exchanges</h2>
      <p>
        If you received a defective or wrong item, we will replace it. Contact
        us with proof of the issue.
      </p>

      <h2>5. Shipping Charges</h2>
      <p>
        Return shipping costs are the responsibility of the customer unless the
        item is defective or incorrect.
      </p>

      <h2>6. How to Initiate a Return</h2>
      <p>
        Email us at support@kidschoice.co.in with your order number and reason
        for return.
      </p>

      <h2>7. Contact Us</h2>
      <p>
        If you have any questions, reach out at:
        <br />
        Email: support@kidschoice.co.in
      </p>
    </div>
  );
};

export default ReturnsExchanges;
